import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { COUNTRY_BY_CODE, COUNTRY_CODE_LOCALE_CODE } from '../constants/country';
import { GeoLocationService } from './geo-location.service';
import { IGeoLocation } from '../interfaces/utils.interface';

@Injectable({
  providedIn: 'root'
})
export class AddressLocationManager {
  constructor(private geoLocation: GeoLocationService) {
  }

  searchAddress(address: string, countryCode: string): Observable<string[]> {
    const country = COUNTRY_BY_CODE[countryCode];
    const query = country + ' ' + address;

    return this.geoLocation.searchPlaces({
      countryCode: countryCode,
      locale: COUNTRY_CODE_LOCALE_CODE[countryCode],
      address: query
    });
  }

  getLocationInfo(address: string, countryCode: string): Observable<IGeoLocation> {
    return this.geoLocation.getLocationInfo(address, COUNTRY_CODE_LOCALE_CODE[countryCode]);
  }
}
